export const getFileSizeInUnits = (size: number) => {
  const kb = 1024;
  const mb = kb * 1024;
  const gb = mb * 1024;

  let sizeInUnits = size;
  let unit = 'B';

  if (size > kb) {
    sizeInUnits = size / kb;
    unit = 'KB';
  }
  if (size > mb) {
    sizeInUnits = size / mb;
    unit = 'MB';
  }
  if (size > gb) {
    sizeInUnits = size / gb;
    unit = 'GB';
  }
  return `${Math.round(sizeInUnits)} ${unit}`;
};
